module.exports = __webpack_public_path__ + "static/media/Mailing-Clergy-CAMPAIGN.3199c6a1.docx";